import figmaIcon from '../assets/design-skill/figma.png'
import adobeXdIcon from '../assets/design-skill/adobexd.png'

export const DesignSkillList = [
    { icon: figmaIcon, title: "Figma" },
    { icon: adobeXdIcon, title: "AdobeXd" }
];